/* INVITATION POPUP */
function validateMembershipsInvitation() {
    const form = document.querySelector('.js-memberships-invitation-form');

    const emailInput = document.querySelector(
        '.js-memberships-invitation-field'
    );
    const emailError = document.querySelector(
        '.js-memberships-invitation-sign'
    );

    let emailDefaultState = true;

    $(emailInput).on('blur', function () {
        if ($(this).val() !== '' && emailDefaultState == true) {
            emailDefaultState = false;
            validateEmail(emailInput, emailError, 'The field is required');
        }
    });

    emailInput.addEventListener('change', () => {
        if (!emailDefaultState) {
            validateEmail(emailInput, emailError, 'The field is required');
        }
    });

    $(form).submit(function (e) {
        e.preventDefault();

        if (validateEmail(emailInput, emailError, 'The field is required')) {
            $(this)
                .off('submit')
                .on('submit', function () {
                    return true;
                });
            $(this)[0].submit();
        } else {
            console.log('Validation failed');
        }
    });

    $(document, '.mdl-wrap').on('click', '.js-btn-field-clear', function () {
        setTimeout(() => {
            validateEmail(emailInput, emailError, 'The field is required');
        }, 0);
    });
}

runIfElementExist(
    validateMembershipsInvitation,
    '.js-memberships-invitation-form'
);

/* EDIT INVITATION POPUP */
function validateMembershipsEditInvitation() {
    const form = document.querySelector('.js-memberships-edit-invitation-form');

    const emailInput = document.querySelector(
        '.js-memberships-edit-invitation-field'
    );
    const emailError = document.querySelector(
        '.js-memberships-edit-invitation-sign'
    );

    let emailDefaultState = true;

    $(emailInput).on('blur', function () {
        if ($(this).val() !== '' && emailDefaultState == true) {
            emailDefaultState = false;
            validateEmail(emailInput, emailError, 'The field is required');
        }
    });

    emailInput.addEventListener('change', () => {
        if (!emailDefaultState) {
            validateEmail(emailInput, emailError, 'The field is required');
        }
    });

    $(form).submit(function (e) {
        e.preventDefault();

        if (validateEmail(emailInput, emailError, 'The field is required')) {
            $(this)
                .off('submit')
                .on('submit', function () {
                    return true;
                });
            $(this)[0].submit();
        } else {
            console.log('Validation failed');
        }
    });

    $(document, '.mdl-wrap').on('click', '.js-btn-field-clear', function () {
        setTimeout(() => {
            validateEmail(emailInput, emailError, 'The field is required');
        }, 0);
    });
}

runIfElementExist(
    validateMembershipsEditInvitation,
    '.js-memberships-edit-invitation-form'
);

/* BULK INVITATION POPUP */
// This function is called when the bulk invitation popup is opened
// in addMembershipsPurchaseBulkInvitationsEmailsFields.js
// it needs because the fields creates dynamically in js.
function validateMembershipsBulkInvitation() {
    const form = document.querySelector('.js-memberships-bulk-invitation-form');
    const fieldsWrapper = document.querySelector(
        '.js-memberships-bulk-invitation-fields-wrapper'
    );
    const emailInputs = fieldsWrapper.querySelectorAll(
        '.js-memberships-bulk-invitation-field'
    );

    emailInputs.forEach((input) => {
        let emailDefaultState = true;
        const emailError = input
            .closest('.js-memberships-bulk-invitation-field-parent')
            ?.querySelector('.js-memberships-invitation-sign');

        $(input).on('blur', function () {
            if ($(this).val() !== '' && emailDefaultState === true) {
                emailDefaultState = false;
                validateEmail(input, emailError, 'This field is required');
            }
        });

        input.addEventListener('input', () => {
            if (!emailDefaultState) {
                validateEmail(input, emailError, 'This field is required');
            }
        });
    });

    $(form).on('submit', function (e) {
        e.preventDefault();

        let allValid = true;

        emailInputs.forEach((input) => {
            const parent = input.closest(
                '.js-memberships-bulk-invitation-field-parent'
            );
            const emailError = parent?.querySelector(
                '.js-memberships-invitation-sign'
            );

            const isValid = validateEmail(
                input,
                emailError,
                'This field is required'
            );
            if (!isValid) {
                allValid = false;
            }
        });

        if (allValid) {
            $(form).off('submit').submit();
            $(this)[0].submit();
        } else {
            console.log('Validation failed');
        }
    });
}

/* FORM WITH CARD */
// function cardNumberFormat() {
//     const card = new Card({
//         form: 'form',
//         container: '.js-card-wrapper',

//         formSelectors: {
//             numberInput: '.js-card-number',
//             expiryInput: '.js-card-expiration-date',
//             cvcInput: '.js-card-cvc',
//             // nameInput: 'input#name' // optional - defaults input[name="name"]
//             // nameInput: 'input[name="first-name"], input[name="last-name"]' // multiple inputs for one field
//         },
//     });
// }

// runIfElementExist(cardNumberFormat, '.js-card-form');

// function validateMembershipsPurchaseForm() {
//     const form = document.querySelector('.js-card-form');
//     const emailInput = document.querySelector(
//         '.js-memberships-purchase-email-field'
//     );
//     const emailError = document.querySelector(
//         '.js-memberships-purchase-email-sign'
//     );

//     let emailDefaultState = true;

//     $(emailInput).on('blur', function () {
//         if ($(this).val() != '' && emailDefaultState == true) {
//             emailDefaultState = false;
//             validateEmail(emailInput, emailError, 'The field is required');
//         }
//     });

//     emailInput.addEventListener('input', () => {
//         if (!emailDefaultState) {
//             validateEmail(emailInput, emailError, 'The field is required');
//         }
//     });

//     // $(form).submit(function (e) {
//     //     e.preventDefault();

//     //     if (validateEmail(emailInput, emailError, 'The field is required')) {
//     //         $(this)
//     //             .off('submit')
//     //             .on('submit', function () {
//     //                 return true;
//     //             });
//     //         $(this)[0].submit();
//     //     } else {
//     //         console.log('Validation failed');
//     //     }
//     // });

//     // $(document, '.mdl-wrap').on(
//     //     'click',
//     //     '.js-btn-field-clear-email',
//     //     function () {
//     //         setTimeout(() => {
//     //             validateEmail(emailInput, emailError, 'The field is required');
//     //         }, 0);
//     //     }
//     // );
// }

// runIfElementExist(validateMembershipsPurchaseForm, '.js-card-form');
